import { render, staticRenderFns } from "./ProductIns.vue?vue&type=template&id=63855c62&scoped=true"
import script from "./ProductIns.vue?vue&type=script&lang=js"
export * from "./ProductIns.vue?vue&type=script&lang=js"
import style0 from "./ProductIns.vue?vue&type=style&index=0&id=63855c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63855c62",
  null
  
)

export default component.exports